import { types, flow, cast } from "mobx-state-tree"
import { billOfMaterialBusiness } from "businesses/bom-business"
import { transformObjectKeys } from "utils/app-helper"

const BillOfMaterialStore = types
  .model({
    data: types.optional(types.frozen(), []),
    bomInfo: types.maybeNull(types.frozen()),
    isLoading: types.maybeNull(types.boolean),
    customFilters: types.maybeNull(types.frozen()),
    selectedId: types.maybeNull(types.string, ""),
    searchText: types.maybeNull(types.string, ""),
    forceReload: types.maybeNull(types.boolean, false),
  })
  .actions(self => ({
    setForceReload() {
      self.forceReload = !self.forceReload
    },
    setData(data) {
      self.data = data
    },
    setSelectedId(id) {
      self.selectedId = id
    },
    setSearchText(val) {
      self.searchText = val
    },
    setCustomFilters(data) {
      self.customFilters = cast(data)
    },
  }))
  .actions(self => ({
    resetData() {
      self.bomInfo = null
      self.selectedId = ""
    },
    loadData: flow(function* (showLoading = true) {
      if (!self.searchText) {
        self.setData([])
        return
      }

      if (showLoading) self.isLoading = true
      const searchParams = {
        ...(self.customFilters || {}),
        search_term: self.searchText || "",
      }
      const data = yield billOfMaterialBusiness.getData(searchParams)
      self.setData(data)
      if (showLoading) self.isLoading = false
    }),
    getBomDetails: flow(function* (productId) {
      const searchParams = {
        item: decodeURIComponent(productId),
      }
      const result = yield billOfMaterialBusiness.getBomDetails(searchParams)
      return result
    }),
    loadDetailData: flow(function* (item) {
      self.selectedId = item

      self.isLoading = true
      const searchParams = {
        item: decodeURIComponent(item),
      }
      const info = yield billOfMaterialBusiness.getDetailData(searchParams)
      self.bomInfo = info
      self.isLoading = false
    }),
    addOrUpdateBOM: flow(function* (data, userName, company) {
      const result = self.selectedId ? yield billOfMaterialBusiness.updateData(data, userName, company) : yield billOfMaterialBusiness.addData(data, userName, company)
      return result ? transformObjectKeys(result, true) : result
    }),
  }))
export default BillOfMaterialStore
